import SitemapTemplate, {
  SitemapTemplateProps,
} from '@/components/template/SitemapTemplate/SitemapTemplate';
import { getCitiesByState } from '@/lib/schema/geo/fetch';
import { City } from '@/lib/schema/geo/types';
import { BasePageProps } from '@/types/page';
import { GetStaticPaths, GetStaticProps } from 'next';

interface PageProps extends BasePageProps {
  state: string;
  cities: City[];
  title: string;
}

const Page: React.FC<PageProps> = ({ state, cities, title }) => {
  const stateLabel = state.toUpperCase();

  const templateProps: SitemapTemplateProps = {
    title,
    categories: [
      {
        categoryName: `${stateLabel} Vehicles by Condition`,
        links: [
          { displayName: 'New', href: `/new-cars/${state}` },
          { displayName: 'Used', href: `/used-cars/${state}` },
        ],
      },
      {
        categoryName: `${stateLabel} Vehicles by City`,
        links: cities.map(({ name, slug }) => {
          return { displayName: name, href: `/sitemap/${state}/${slug}` };
        }),
      },
    ],
  };

  return <SitemapTemplate {...templateProps} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<PageProps> = async (context) => {
  const state = (context.params?.state as string).toLowerCase();
  const title = `${state.toUpperCase()} Vehicles Sitemap`;

  const cities = await getCitiesByState(state);
  if (!cities) {
    return { notFound: true };
  }

  return { props: { state, cities, title, metadata: { title } } };
};

export default Page;
